import React, { useRef } from 'react';
import {
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartsList.styles';
import {
	ApButtonIcon,
	ApLoaderDefault,
	ApLoaderText,
	ApMenu,
	ApMenuItem,
} from '@alixpartners/ui-components';
import { EXPORT_OPTIONS } from 'CategoryManagement/utils';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsTreemap from 'highcharts/modules/treemap';
import { useSpendByCountryContext } from 'contexts/CategoryDashboardCharts/SpendByCountryProvider';
HighchartsTreemap(Highcharts);

const SpendByCountry = ({ chartTitle }) => {
	const { isLoading, data, options } = useSpendByCountryContext();
	const chartRef = useRef();
	const getChartInstance = () => {
		return chartRef && chartRef.current && chartRef.current.chart;
	};

	const handleChartExport = option => {
		const chartInstance = getChartInstance();
		if (chartInstance && option.value === 'png') {
			chartInstance.exportChart(
				{
					filename: chartTitle,
				},
				{
					chart: { width: 1200 },
				}
			);
		}
		if (option.value === 'xlsx') {
			this.handleChartDataExport();
		}
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				<ApMenu button={<ApButtonIcon iconName="download" />}>
					{EXPORT_OPTIONS.map(option => (
						<ApMenuItem
							key={option.value}
							onClick={() => handleChartExport(option)}
						>
							{option.label}
						</ApMenuItem>
					))}
				</ApMenu>
			</Header>
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							ref={chartRef}
						/>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default SpendByCountry;
